<div class="d-flex p-4 justify-content-between"
     [formGroup]="transportFormGroup">
  <div class="form">
    <h4>Transport Modal</h4>
    <small class="form-text text-muted">This will automatically calculate the transport charges. </small>
    <div class="form-group pt-4">
      <label required>Service Center</label>
      <input type="text"
             class="form-control"
             (keydown.enter)="$event.preventDefault()"
             placeholder="Search for a service center"
             autocorrect="off"
             autocapitalize="off"
             [value]="transportFormGroup.value.service_center!.name!"
             spellcheck="off"
             type="text"
             #search />
    </div>
    <div class="form-group">
      <label required>Base Radius(km)</label>
      <input type="number"
             formControlName="base_radius_in_km"
             placeholder="Base Radius"
             class="form-control">
    </div>
    <div class="form-group">
      <label required>Base Transport Cost</label>
      <input type="number"
             class="form-control"
             formControlName="base_transport"
             placeholder="Base Transport Cost">
    </div>
    <div class="form-group">
      <label required>Cost per extra mile</label>
      <input type="number"
             formControlName="cost_per_extra_km"
             class="form-control"
             placeholder="Cost per extra mile">
    </div>
  </div>
  <div>
    <app-service-action-bar></app-service-action-bar>
  </div>
</div>
<router-outlet></router-outlet>
